import { async, sync } from "../api/automation";
import { BuildRegisterServerModal } from "../Components/ServerManagement/BuildRegisterServerModal";
import {
  ALL_SERVER,
  CHANGE_REGISTER_SERVER_DATA,
  CHANGE_SERVER_MANAGER_TAB,
  CLOSE_ADD_EMULATOR_MODAL_VISIBLE,
  CREATE_VIRTUAL_DEVICE_LOADER,
  EMULATOR_SUPPORTED_DEVICE_LIST,
  EMULATOR_SUPPORTED_OS_LIST,
  ERROR_TYPE,
  FETCH_ALL_PROJECTS,
  FETCH_ALL_SERVER,
  FETCH_DEVICE_DETAILS,
  FETCH_SERVER_TYPES,
  HIDE_REGISTER_SERVER_MODAL,
  OPEN_ADD_EMULATOR_MODAL_VISIBLE,
  PREVIOUS_REGISTER_SERVER_DATA,
  RECORD_10_PER_PAGE,
  SERVER_DEVICE_LOADING,
  SERVER_LOADING,
  START_STOP_VIRTUAL_DEVICE_LOADER,
  SUCCESS_STATUS,
  SUCCESS_TYPE,
  UPDATE_ADD_EMULATOR,
  VISIBLE_REGISTER_SERVER_MODAL,
} from "../Constants";
import { showNotification, updateResponse } from "../Util";

export function changeServerManagerTab(selectedTab) {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_SERVER_MANAGER_TAB, selectedTab });
  };
}

export function handleChangeRegisterServerData(registerServerData) {
  return async (dispatch) => {
    dispatch({ type: CHANGE_REGISTER_SERVER_DATA, data: registerServerData });
  };
}

export function fetchServerType(id) {
  return async (dispatch, getState) => {
    return async("serverType/getAll", "GET").then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch({ type: FETCH_SERVER_TYPES, response });
      }
    });
  };
}

export function fetchAllServer(orgId, serverType, pageNumber) {
  return async (dispatch, getState) => {
    dispatch({ type: SERVER_LOADING, isLoading: true });
    let obj = {
      orgId: orgId,
      serverName: serverType ? serverType : "",
      pageNumber: pageNumber || 1,
      recordsPerPage: RECORD_10_PER_PAGE,
    };
    return async("server/findByOrgId", "GET", obj).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch({ type: FETCH_ALL_SERVER, response, pageNumber });
      }
      dispatch({ type: SERVER_LOADING, isLoading: false });
    });
  };
}

export function saveRegisterServer(orgId, serverData, currentServerListPage) {
  return async (dispatch, getState) => {
    const stateServerData = getState().ServerReducer.registerServerData;
    let token =
      localStorage.getItem("xpressToken") &&
      localStorage.getItem("xpressToken") !== "undefined" &&
      localStorage.getItem("xpressToken") != null
        ? "Bearer " + localStorage.getItem("xpressToken")
        : "";
    let requestedUser = localStorage.getItem("requestedUser");

    let preObj = {};

    if (serverData) {
      preObj.id = serverData?.id;
      preObj.serverName = serverData?.serverName;
      preObj.serverType = serverData?.serverType?.id;
      preObj.localIp = serverData?.localIp;
      preObj.isActive = serverData?.isActive === 1 ? 0 : 1;
      preObj.serverIp = serverData?.serverIp;
    } else {
      preObj = stateServerData;
    }
    try {
      const url = new URL(preObj.serverIp);
      url.pathname = "/server/info";
      const apiUrl = url.toString();
      dispatch({ type: SERVER_LOADING, isLoading: true });
      let response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
          requestedUser: requestedUser,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      });
      response = await response.json();
      response = updateResponse(response);

      if (response.status === "Success") {
        preObj.orgId = orgId;
        preObj.uuid = response.data?.serverId;
        response = await async("server/save", "POST", preObj);
        response = updateResponse(response);

        if (response.status === "Success") {
          showNotification("Success", response.message);
          dispatch(fetchAllServer(orgId, "", currentServerListPage));
          dispatch(changeServerManagerTab(ALL_SERVER));
          dispatch({ type: SERVER_LOADING, isLoading: false });
        } else {
          showNotification("error", response.message);
          dispatch({ type: SERVER_LOADING, isLoading: false });
        }
      } else {
        showNotification("error", response.message);
        dispatch({ type: SERVER_LOADING, isLoading: false });
      }
    } catch (error) {
      showNotification("error", "Please start the server for your device first.");
      dispatch({ type: SERVER_LOADING, isLoading: false });
    } finally {
      dispatch(hideRegisterServerModal());
    }
  };
}

export function getServerDataById(id) {
  return async (dispatch, getState) => {
    dispatch({ type: SERVER_LOADING, isLoading: true });
    return async("server/findById", "GET", { id }).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch({
          type: CHANGE_REGISTER_SERVER_DATA,
          data: new BuildRegisterServerModal(response?.data),
        });
        dispatch({
          type: PREVIOUS_REGISTER_SERVER_DATA,
          data: new BuildRegisterServerModal(response?.data),
        });
      }
      dispatch({ type: SERVER_LOADING, isLoading: false });
    });
  };
}

export function getAllDeviceByServerId(serverId, serverIp) {
  return async (dispatch, getState) => {
    let response = await sync(
      "device/getConnectedDevices",
      "GET",
      { serverId },
      serverIp
    );
    response = updateResponse(response);
    response.serverId = serverId;
    if (response.status === SUCCESS_STATUS) {
      dispatch({ type: FETCH_DEVICE_DETAILS, response });
    }
    dispatch({ type: SERVER_DEVICE_LOADING, isLoading: false });
  };
}

export function fetchProjectList(orgId) {
  return async (dispatch, getState) => {
    return async("projectUserAssoc/getByUserIdAndOrgId", "GET", { orgId }).then(
      (response) => {
        response = updateResponse(response);
        if (response.status === SUCCESS_STATUS) {
          dispatch({ type: FETCH_ALL_PROJECTS, response });
        }
      }
    );
  };
}

export function saveProjects(
  orgId,
  serverId,
  serverIp,
  deviceData,
  deAuthorization,
  selectedProject,
  iosTeamId
) {
  return async (dispatch, getState) => {
    let preObj = deviceData;
    preObj.serverId = serverId;
    preObj.orgId = parseInt(orgId);
    if (deAuthorization) {
      preObj.isActive = 0;
      preObj.prevListOfprojects = deviceData?.listOfProjectIds || [];
      preObj.listOfProjectIds = [];
    } else {
      preObj.isActive = 1;
      preObj.prevListOfprojects = deviceData?.listOfProjectIds || [];
      preObj.listOfProjectIds = selectedProject || [];
      preObj.iosDevelopmentTeamId = iosTeamId;
    }

    return async("device/save", "POST", preObj).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch(getAllDeviceByServerId(serverId, serverIp));
        showNotification(SUCCESS_TYPE, response?.message);
      } else {
        showNotification(ERROR_TYPE, response?.message);
      }
    });
  };
}

export function startVirtualDevice(data, serverId, serverIp) {
  return async (dispatch, getState) => {
    dispatch({
      type: START_STOP_VIRTUAL_DEVICE_LOADER,
      visible: true,
      serverId,
    });
    let requestData = {
      name: data.name,
      targetUniqueId: data.targetUniqueId,
      platformType: data?.platform,
      wipePreviousData: "false",
    };
    return async(
      "virtualDevice/startVirtualDevice",
      "POST",
      requestData,
      serverIp
    ).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        new Promise((resolve) =>
          resolve(dispatch(getAllDeviceByServerId(serverId, serverIp)))
        ).then((resp) => {
          dispatch({
            type: START_STOP_VIRTUAL_DEVICE_LOADER,
            visible: false,
            serverId,
          });
        });
      }
    });
  };
}

export function stopVirtualDevice(data, serverId, serverIp) {
  return async (dispatch, getState) => {
    dispatch({
      type: START_STOP_VIRTUAL_DEVICE_LOADER,
      visible: true,
      serverId,
    });
    let requestData = {
      name: data.name,
      targetUniqueId: data.targetUniqueId,
      platformType: data?.platform,
      wipePreviousData: "false",
    };
    return async(
      "virtualDevice/stopVirtualDevice",
      "POST",
      requestData,
      serverIp
    ).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        new Promise((resolve) =>
          resolve(dispatch(getAllDeviceByServerId(serverId, serverIp)))
        ).then((resp) => {
          dispatch({
            type: START_STOP_VIRTUAL_DEVICE_LOADER,
            visible: false,
            serverId,
          });
        });
      }
    });
  };
}
export function openAddEmulatorModalVisible(serverId, serverIp, serverArmType) {
  return async (dispatch, getState) => {
    dispatch({
      type: OPEN_ADD_EMULATOR_MODAL_VISIBLE,
      serverId,
      serverIp,
      serverArmType,
    });
  };
}
export function closeAddEmulatorModalVisible() {
  return async (dispatch, getState) => {
    dispatch({ type: CLOSE_ADD_EMULATOR_MODAL_VISIBLE });
  };
}
export function createVirtualDevice(orgId) {
  return async (dispatch, getState) => {
    const {
      addEmulatorServerId,
      addEmulatorServerIp,
      addEmulatorServerArmType,
    } = getState().ServerReducer;
    let { addEmulatorObj}= getState().ServerReducer;

    const deviceSaveObj = {
      name: addEmulatorObj.deviceName,
      osVersion: addEmulatorObj.osVersion,
      platform: addEmulatorObj.platformType,
      udid: null,
      serverId: addEmulatorServerId,
      isActive: 1,
      listOfProjectIds: [],
      prevListOfprojects: [],
      isVirtualDevice: 1,
      orgId: parseInt(orgId),
      brand:"google",
      model:addEmulatorObj?.androidAvdDeviceName
    };
    return async("device/save", "POST", deviceSaveObj).then((resp) => {
      resp = updateResponse(resp);
      if (resp.status === SUCCESS_STATUS) {
        addEmulatorObj=resp?.data?.name?{...addEmulatorObj,deviceName:resp?.data?.name}:{...addEmulatorObj};
        console.log(addEmulatorObj)
        return async(
          "virtualDevice/createVirtualDevice",
          "POST",
          { ...addEmulatorObj, androidArmDevice: addEmulatorServerArmType },
          addEmulatorServerIp
        ).then((response) => {
          response = updateResponse(response);
          if (response.status === SUCCESS_STATUS) {
            dispatch(
              getAllDeviceByServerId(addEmulatorServerId, addEmulatorServerIp)
            );
          }
        });
      }
    });
  };
}
export function getSupportedDeviceOSVersion(platform) {
  return async (dispatch, getState) => {
    const { addEmulatorServerId, addEmulatorServerIp } =
      getState().ServerReducer;
    dispatch({ type: CREATE_VIRTUAL_DEVICE_LOADER, visible: true });
    return async(
      "virtualDevice/getAvailableOSVersion",
      "GET",
      { platform },
      addEmulatorServerIp
    ).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch({ type: EMULATOR_SUPPORTED_OS_LIST, data: response.data });
      }
    });
  };
}
export function getSupportedVirtualDevice(platform) {
  return async (dispatch, getState) => {
    const { addEmulatorServerId, addEmulatorServerIp } =
      getState().ServerReducer;
    return async(
      "virtualDevice/getAvailableDevicesForVirtual",
      "GET",
      { platform },
      addEmulatorServerIp
    ).then((response) => {
      response = updateResponse(response);
      if (response.status === SUCCESS_STATUS) {
        dispatch({ type: EMULATOR_SUPPORTED_DEVICE_LIST, data: response.data });
      }
    });
  };
}
export function updateAddEmulator(data) {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_ADD_EMULATOR, data });
  };
}

export const visibleRegisterServerModal=()=>{
  return async(dispatch)=>{
    dispatch({ type: VISIBLE_REGISTER_SERVER_MODAL  });

  }
}

export const hideRegisterServerModal=()=>{
  return async(dispatch)=>{
    dispatch({ type: HIDE_REGISTER_SERVER_MODAL  });

  }
}